<template>
  <layout-content>
    <form-component v-bind="form_data" />
  </layout-content>
</template>

<script>
  import { mapMutations } from 'vuex';
  import FormComponent from '@pbx/components/phone-lists/form';
  import { PhoneListService } from '@pbx/services/PhoneListService';

  export default {
    components: {
      FormComponent
    },

    data() {
      return {
        form_data: {
          id: null,
          item: null
        }
      };
    },

    created() {
      if (this.$route.name === 'pbx.phone-list.edit') {
        const id = this.$route.params.id;
        this.set_id(id);

        PhoneListService.getItem(id)
          .then(item => {
            const { id } = item;
            this.form_data = { id, item };
            this.endLoadingPage();
          })
          .catch(e => this.showPageError(e));
      }
    },

    destroyed() {
      this.clear_id();
    },

    methods: {
      ...mapMutations({
        set_id: 'pbx/phone-lists/form/setId',
        clear_id: 'pbx/phone-lists/form/clearId'
      })
    }
  };
</script>
